import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Smart AI Speaker",
        price: 150,
        disprice: 120,
        stock: 10,
        content:
            "Enhance your workspace with our Smart AI Speaker, designed for seamless communication and superior audio quality. Ideal for conferences, virtual meetings, and smart office environments.",
        description:
            "Our Smart AI Speaker delivers crystal-clear sound and intelligent voice assistance. With advanced noise cancellation and multi-device connectivity, it's perfect for business meetings and hands-free productivity.",
        category: ["Smart Devices", "Home & Automation"],
        tags: ["Smart", "Home", "Tech"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Premium Aluminum and ABS Plastic" },
            { id: 2, title: "Connectivity", content: "Bluetooth 5.0 & Wi-Fi" },
            { id: 3, title: "Voice Control", content: "Compatible with Alexa and Google Assistant" },
            { id: 4, title: "Battery Life", content: "Up to 12 hours" },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "David Johnson",
                date: "September 5, 2024",
                rating: 5,
                content: "Incredible sound quality and seamless integration with my smart home devices. Highly recommend!",
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emily Chen",
                date: "September 10, 2024",
                rating: 4.9,
                content: "The AI functionality is impressive, and the design fits perfectly in my modern office setup.",
            },
        ],
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Toy Robot",
        price: 50,
        disprice: 40,
        stock: 10,
        content:
            "Bring joy and creativity to kids with our Interactive Toy Robot. Equipped with advanced sensors and programmable functions, it offers endless fun and learning opportunities.",
        description:
            "Our Interactive Toy Robot is perfect for tech enthusiasts and young inventors. With voice recognition, movement control, and educational games, it provides an engaging and educational experience for children of all ages.",
        category: ["Robotics & Drones", "Smart Devices"],
        tags: ["Robot", "Smart", "Gadget"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic and Metal Components" },
            { id: 2, title: "Power Source", content: "Rechargeable Battery" },
            { id: 3, title: "Features", content: "Voice Command, Movement Control, and Programming Options" },
            { id: 4, title: "Age Range", content: "6 years and above" },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "John Doe",
                date: "August 10, 2024",
                rating: 5,
                content: "My kids love the Toy Robot! It keeps them entertained and helps them learn coding basics.",
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Emily Smith",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Great quality and functionality. A must-have for tech-loving kids!",
            },
        ],
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Gaming Headset",
        price: 75,
        disprice: 60,
        stock: 15,
        content:
            "Immerse yourself in the ultimate gaming experience with our high-performance Gaming Headset. Designed for crystal-clear audio and maximum comfort during long gaming sessions.",
        description:
            "Our Gaming Headset delivers exceptional sound quality with noise-canceling technology and a comfortable, adjustable design. Perfect for gamers who demand top-notch performance and style.",
        category: ["Gaming & Entertainment", "Smart Devices"],
        tags: ["Gaming", "Wireless", "Entertainment"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connectivity", content: "Wired & Wireless Options" },
            { id: 2, title: "Sound Quality", content: "Surround Sound 7.1" },
            { id: 3, title: "Microphone", content: "Detachable Noise-Canceling Mic" },
            { id: 4, title: "Compatibility", content: "PC, Console, Mobile" },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Alex Johnson",
                date: "August 10, 2024",
                rating: 5,
                content: "Incredible sound quality and super comfortable for long gaming sessions!",
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Emma Brown",
                date: "August 15, 2024",
                rating: 4.8,
                content: "The noise-canceling feature is a game-changer. Highly recommend this headset!",
            },
        ],
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Health Tracker",
        price: 150,
        disprice: 120,
        stock: 10,
        content:
            "Monitor your fitness and well-being with our advanced Health Tracker. Designed to track your steps, heart rate, and sleep patterns, this device helps you stay on top of your health goals.",
        description:
            "Our Health Tracker is the perfect companion for those looking to improve their fitness and overall health. With real-time data tracking, customizable fitness goals, and seamless integration with your smartphone, achieving a healthier lifestyle has never been easier.",
        category: ["Health & Fitness", "Smart Devices"],
        tags: ["Fitness", "Smart", "Tech"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Silicone and Metal" },
            { id: 2, title: "Battery Life", content: "Up to 7 Days" },
            { id: 3, title: "Compatibility", content: "iOS and Android" },
            { id: 4, title: "Water Resistance", content: "Yes" },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Emma Johnson",
                date: "August 10, 2024",
                rating: 5,
                content: "Excellent tracker with accurate data and great battery life! Highly recommend.",
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Liam Brown",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Great for monitoring my fitness progress. Very user-friendly and stylish.",
            },
        ],
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Robot Camera",
        price: 150,
        disprice: 130,
        stock: 10,
        content:
            "Enhance your surveillance with our cutting-edge Robot Camera, equipped with smart tracking and night vision for ultimate security.",
        description:
            "Our Robot Camera is designed for advanced monitoring with 360-degree rotation, motion detection, and remote control via a mobile app. Ideal for home security and office surveillance.",
        category: ["Robotics & Drones", "Home & Automation"],
        tags: ["Robot", "Home", "Automation"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p HD" },
            { id: 2, title: "Connectivity", content: "Wi-Fi Enabled" },
            { id: 3, title: "Features", content: "Night Vision, Motion Detection, 360-degree Rotation" },
            { id: 4, title: "Control", content: "Mobile App Integration" },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Alex Johnson",
                date: "September 5, 2024",
                rating: 5,
                content: "Incredible clarity and smooth control. Perfect for home security!",
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Emily White",
                date: "September 12, 2024",
                rating: 4.8,
                content: "Great features and easy setup. Love the motion detection capability.",
            },
        ],
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Gaming Console",
        price: 299,
        disprice: 249,
        stock: 10,
        content:
            "Experience next-level gaming with our state-of-the-art Gaming Console. With stunning graphics, immersive sound, and a vast game library, it's perfect for casual and hardcore gamers alike.",
        description:
            "Our Gaming Console delivers lightning-fast performance and seamless gameplay. Equipped with advanced hardware and a sleek design, it supports multiplayer experiences and streaming capabilities, making it the ultimate entertainment hub.",
        category: ["Gaming & Entertainment", "Smart Devices"],
        tags: ["Gaming", "Entertainment", "Tech"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Processor", content: "High-Performance CPU & GPU" },
            { id: 2, title: "Storage", content: "1TB SSD" },
            { id: 3, title: "Connectivity", content: "Wi-Fi 6, Bluetooth 5.0" },
            { id: 4, title: "Controller", content: "Wireless with Haptic Feedback" },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Alex Johnson",
                date: "September 5, 2024",
                rating: 5,
                content: "Incredible performance and stunning visuals. The best console I've ever owned!",
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Emily Chen",
                date: "September 10, 2024",
                rating: 4.9,
                content: "Smooth gameplay and excellent controller responsiveness. Worth every penny!",
            },
        ],
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Advanced Drone",
        price: 499,
        disprice: 450,
        stock: 10,
        content:
            "Experience unparalleled aerial photography and videography with our Advanced Drone, equipped with high-resolution cameras and smooth flight controls.",
        description:
            "Our Advanced Drone is designed for both hobbyists and professionals. With its 4K camera, stable flight technology, and long battery life, capturing stunning visuals from the sky has never been easier. Ideal for outdoor adventures and creative projects.",
        category: ["Robotics & Drones", "Gaming & Entertainment"],
        tags: ["Robot", "Gadget", "Tech"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Camera Quality", content: "4K Ultra HD" },
            { id: 2, title: "Flight Time", content: "30 minutes" },
            { id: 3, title: "Range", content: "Up to 5 km" },
            { id: 4, title: "Control", content: "Remote and Mobile App" },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Alex Johnson",
                date: "September 5, 2024",
                rating: 5,
                content: "Amazing drone with incredible camera quality. Perfect for capturing aerial shots!",
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Emily Chen",
                date: "September 10, 2024",
                rating: 4.9,
                content: "Smooth flight experience and excellent range. Highly recommend for enthusiasts!",
            },
        ],
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "VR Headset",
        price: 499,
        disprice: 450,
        stock: 8,
        content:
            "Step into the future of immersive experiences with our state-of-the-art VR Headset. Perfect for gaming, virtual tours, and creative exploration.",
        description:
            "Our VR Headset delivers a fully immersive virtual reality experience with cutting-edge graphics and responsive motion tracking. Designed for comfort and compatibility with multiple platforms, it offers hours of seamless entertainment.",
        category: ["Gaming & Entertainment", "Smart Devices"],
        tags: ["Gaming", "Entertainment", "Wireless"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "4K Ultra HD" },
            { id: 2, title: "Field of View", content: "120 Degrees" },
            { id: 3, title: "Connectivity", content: "Wireless and USB-C" },
            { id: 4, title: "Comfort", content: "Ergonomic Design with Adjustable Straps" },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Ethan Blake",
                date: "August 22, 2024",
                rating: 5,
                content: "Incredible immersion and top-notch build quality. Worth every penny!",
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Lily Chen",
                date: "August 25, 2024",
                rating: 4.9,
                content: "Best VR headset I've used. The visuals and tracking are flawless!",
            },
        ],
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Smart Vacuum",
        price: 299,
        disprice: 249,
        stock: 8,
        content:
            "Experience hassle-free cleaning with our advanced Smart Vacuum. Equipped with intelligent navigation and powerful suction, it keeps your home spotless with minimal effort.",
        description:
            "The Smart Vacuum is designed for modern living. With smart mapping technology, app control, and automatic dirt disposal, it delivers exceptional cleaning performance for every corner of your home.",
        category: ["Home & Automation", "Smart Devices"],
        tags: ["Automation", "Home", "Smart"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Suction Power", content: "2000 Pa" },
            { id: 2, title: "Battery Life", content: "120 minutes" },
            { id: 3, title: "Navigation System", content: "Lidar Mapping" },
            { id: 4, title: "App Control", content: "Yes" },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Emma Johnson",
                date: "September 5, 2024",
                rating: 5,
                content: "Absolutely love this vacuum! It cleans every corner efficiently and saves so much time.",
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "David Lee",
                date: "September 12, 2024",
                rating: 4.8,
                content: "Great performance and easy to control with the app. Highly recommend!",
            },
        ],
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Audio Speaker",
        price: 25,
        disprice: 20,
        stock: 5,
        content:
            "Experience high-quality sound with our Premium Audio Speaker, perfect for events, parties, and home entertainment. With powerful bass and crystal-clear audio, this speaker delivers an immersive listening experience.",
        description:
            "Our Premium Audio Speaker is designed for music enthusiasts and event organizers. With advanced sound technology and a sleek design, it enhances your audio experience and creates the perfect ambiance.",
        category: ["Smart Devices", "Home & Automation"],
        tags: ["Smart", "Wireless", "Entertainment"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Plastic and Metal" },
            { id: 2, title: "Power Output", content: "50W RMS" },
            { id: 3, title: "Connectivity", content: "Bluetooth, AUX, USB" },
            { id: 4, title: "Battery Life", content: "10 hours" },
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Amazing sound quality and perfect for outdoor parties! Highly recommend.",
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Great speaker with clear audio and deep bass. Perfect for home use.",
            },
        ],
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Toy Robot",
        price: 25,
        disprice: 20,
        stock: 5,
        content:
            "Discover endless fun and learning with our Interactive Toy Robot. With advanced sensors and customizable features, it's perfect for kids and tech enthusiasts.",
        description:
            "Our Interactive Toy Robot is designed to entertain and educate. With smart programming, voice recognition, and playful movements, it offers a unique experience for all ages.",
        category: ["Robotics & Drones", "Smart Devices"],
        tags: ["Robot", "Smart", "Gadget"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic and Metal Components" },
            { id: 2, title: "Features", content: "Voice Recognition, Obstacle Detection" },
            { id: 3, title: "Battery Life", content: "8 hours" },
            { id: 4, title: "Connectivity", content: "Bluetooth and Remote Control" },
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "A fantastic toy with great interactive features. My kids love it!",
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Highly engaging and fun to play with. Perfect for tech-savvy kids.",
            },
        ],
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Gaming Headset",
        price: 75,
        disprice: 60,
        stock: 10,
        content:
            "Experience immersive sound with our high-performance Gaming Headset. Designed for comfort and crystal-clear audio, perfect for long gaming sessions.",
        description:
            "Our Gaming Headset delivers exceptional audio quality with noise-canceling technology and a comfortable fit. Ideal for both casual and professional gamers.",
        category: ["Gaming & Entertainment", "Smart Devices"],
        tags: ["Gaming", "Wireless", "Entertainment"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Plastic and Metal" },
            { id: 2, title: "Features", content: "Surround Sound, Noise Cancelling Microphone" },
            { id: 3, title: "Connectivity", content: "Wired and Wireless Options" },
            { id: 4, title: "Compatibility", content: "PC, Console, and Mobile" },
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Incredible sound quality and very comfortable for long gaming sessions!",
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Great audio and the noise-canceling mic works perfectly. Highly recommended!",
            },
        ],
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Fitness Tracker",
        price: 50,
        disprice: 40,
        stock: 15,
        content:
            "Track your health and fitness goals with our advanced Fitness Tracker. Equipped with heart rate monitoring and activity tracking features.",
        description:
            "Our Fitness Tracker helps you stay active and monitor your progress with real-time data on steps, calories burned, and heart rate. Perfect for fitness enthusiasts.",
        category: ["Health & Fitness", "Smart Devices"],
        tags: ["Fitness", "Smart", "Tech"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Silicone and Plastic" },
            { id: 2, title: "Features", content: "Heart Rate Monitoring, Step Tracking, Sleep Analysis" },
            { id: 3, title: "Battery Life", content: "Up to 7 Days" },
            { id: 4, title: "Compatibility", content: "iOS and Android" },
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Accurate tracking and excellent battery life. Highly recommend for fitness enthusiasts!",
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Great design and functionality. Tracks everything I need for my workouts.",
            },
        ],
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Robot Camera",
        price: 150,
        disprice: 130,
        stock: 10,
        content:
            "Enhance your home security with our advanced Robot Camera. Equipped with motion detection and remote control features.",
        description:
            "Our Robot Camera offers real-time monitoring, night vision, and two-way audio communication. Ideal for home security and surveillance.",
        category: ["Robotics & Drones", "Home & Automation"],
        tags: ["Robot", "Home", "Automation"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic and Metal" },
            { id: 2, title: "Features", content: "Motion Detection, Night Vision, Two-Way Audio" },
            { id: 3, title: "Connectivity", content: "Wi-Fi Enabled" },
            { id: 4, title: "Compatibility", content: "iOS and Android" },
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Excellent camera with clear visuals and smooth remote control. Great for home security!",
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "Impressive features and easy setup. The motion detection is spot on!",
            },
        ],
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Gaming Console",
        price: 300,
        disprice: 280,
        stock: 15,
        content:
            "Experience next-level gaming with our high-performance Gaming Console. Smooth graphics and immersive gameplay guaranteed.",
        description:
            "Our Gaming Console features ultra-fast processing, 4K resolution, and a vast game library. Perfect for solo and multiplayer experiences.",
        category: ["Gaming & Entertainment", "Smart Devices"],
        tags: ["Gaming", "Entertainment", "Tech"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic and Metal" },
            { id: 2, title: "Performance", content: "High-Speed Processor and 4K Graphics" },
            { id: 3, title: "Connectivity", content: "Wi-Fi and Bluetooth Enabled" },
            { id: 4, title: "Compatibility", content: "All Major Game Platforms" },
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Incredible graphics and seamless performance. My go-to gaming device!",
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "The game library is extensive, and the console runs flawlessly. Love it!",
            },
        ],
    }
];

export default products;